/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cookie_medium'
export default icon
